module.exports = __webpack_public_path__ + "img/logo.dd5c110d.png";